import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useRef, useCallback, useMemo } from "react";
import { uniq, prop, propEq, equals } from "ramda";
import { useCustomEffect } from "hooks";
/*
  { gender: 'Total' },
  { gender: 'Total', age: '10-19' },
  gender is always specified in the submeasure model, either by an actual gender or 'Total'
  age isn't present if age = Total
*/
export default function useSubmeasures(query, metadata, setQuery) {
  var isNotProcent = metadata.measureUnit !== "%";
  var graphSelected = useCallback(function (_query) {
    return _query.graphSelected === "barchart" && isNotProcent && _query.measureIds.length > 1 ? "stackedBarchart" : _query.graphSelected;
  }, [isNotProcent]);
  var submeasures = useMemo(function () {
    return (metadata === null || metadata === void 0 ? void 0 : metadata.subMeasures.map(function (id) {
      return _objectSpread({
        id: id
      }, metadata.library[id]);
    })) || [];
  }, [metadata]);
  var genderSubmeasures = submeasures.map(prop("gender")).filter(function (x) {
    return x && x.gender !== "Total";
  });
  var ageSubmeasures = uniq(submeasures.map(prop("age")).filter(Boolean));
  var selectedSubmeasures = query.measureIds.map(function (id) {
    return submeasures.find(propEq("id", id));
  }).filter(Boolean);
  var selectedGenders = useRef(selectedSubmeasures.map(prop("gender")));
  var selectedAge = useRef(selectedSubmeasures.map(prop("age")));
  useCustomEffect(function () {
    selectedGenders.current = selectedSubmeasures.map(prop("gender"));
    selectedAge.current = selectedSubmeasures.map(prop("age"));
  }, [selectedSubmeasures]);
  var getSubmeasureId = useCallback(function (gender, age) {
    var _submeasures$find;
    return (_submeasures$find = submeasures.find(function (submeasure) {
      return equals(submeasure.age, age) && equals(submeasure.gender, gender);
    })) === null || _submeasures$find === void 0 ? void 0 : _submeasures$find.id;
  }, [submeasures]);
  var removeTotal = function removeTotal(x) {
    return x !== "Total" ? x : undefined;
  };
  var addTotal = function addTotal(x) {
    return !x ? "Total" : x;
  };
  var updateGender = useCallback(function (gender) {
    return setQuery({
      sort: gender === "ManWoman" && graphSelected(query) !== "stackedBarchart" && ["asc", "desc"].includes(query.sort) ? "alpha" : query.sort,
      measureIds: gender === "ManWoman" ? [getSubmeasureId("Male", selectedAge.current[0]), getSubmeasureId("Female", selectedAge.current[0])] : [getSubmeasureId(gender, selectedAge.current[0]) || query.parentMeasure]
    });
  }, [query, setQuery, graphSelected, getSubmeasureId]);
  var updateAge = useCallback(function (age) {
    return setQuery({
      measureIds: selectedSubmeasures.length === 2 ? [getSubmeasureId("Male", removeTotal(age)), getSubmeasureId("Female", removeTotal(age))] : [getSubmeasureId(addTotal(selectedGenders.current[0]), removeTotal(age)) || query.parentMeasure]
    });
  }, [query, setQuery, getSubmeasureId, selectedSubmeasures]);
  return {
    genderSubmeasures: genderSubmeasures,
    ageSubmeasures: ageSubmeasures,
    selectedGenders: selectedGenders,
    selectedAge: selectedAge,
    updateGender: updateGender,
    updateAge: updateAge
  };
}